import type {SelectComponentValue} from 'nutshell-core/types';
import {getApiTypeFromGraphQLTypename} from 'nutshell-core/utils';

import type {EmailAddress as EmailAddressFragment} from 'nutshell-graphql-types';

/**
 * Our select component expects id/name pairs, but our email address objects
 * are a little more complicated. This is just a simple translation function
 * to make them select-compatible.
 *
 * @param  {array} emailAddresses - Array of email address objects
 * @return {array}                  Array of select options
 */
export function createSelectOptionsFromEmailAddresses(
    emailAddresses: EmailAddressFragment[]
): SelectComponentValue[] {
    return emailAddresses.map((emailAddress: EmailAddressFragment) => {
        const type =
            emailAddress.entity && emailAddress.entity.__typename
                ? getApiTypeFromGraphQLTypename(emailAddress.entity.__typename)
                : null;

        return {
            id: emailAddress.value.address,
            name: emailAddress.value.formatted,
            type,
        };
    });
}
